import React, { Component } from 'react';
import { connect } from 'react-redux';

import Loader from '../Loader';

import { TableRow, TableCell, Grid, Button } from '@mui/material';
import PidTitle from './TrplFormRowComponents/PidTitle';

import TrplFormValRenderer from './TrplFormValRenderer';
import TrplFormCustomRow from './TrplFormCustomRow';

import { findLastRstInPredicateChain, prdcParamsForm, boxParamsForm } from '../../utils';
import CustomChainBlock from './CustomChainBlock';

const StyledCell = ({ children, style, className }) => (
  <TableCell
    className={className}
    style={{
      borderBottom: 'none',
      ...style,
    }}
  >
    {children}
  </TableCell>
);

class TrplFormRow extends Component {
  state = {
    groupWidth: 0,
    anchorEl: null,
    trplsMetaData: null,
    screenResized: false,
    flexSetting: 'nowrap',
    loadingAddCustom: false,
    containerDisplay: 'contents',
  };

  _isMounted = false;

  shouldComponentUpdate = (nextProps, nextState) => {
    const { rstData, getTrplNode, rst, ancestorId } = this.props;

    return (
      this.props.rst.type === 'custom' ||
      JSON.stringify(nextProps.rstData) !== JSON.stringify(rstData) ||
      (rst.id && Array.isArray(rst.id) && (getTrplNode(rst.id, 0, ancestorId) !== this.state.trplsNode)) ||
      (rstData && rstData.type === 'node') ||
      (rstData && nextProps.rstData && nextProps.rstData.mode !== rstData.mode) ||
      nextState.trplsMetaData !== this.state.trplsMetaData ||
      nextState.anchorEl !== this.state.anchorEl ||
      nextState.flexSetting !== this.state.flexSetting ||
      nextState.groupWidth !== this.state.groupWidth ||
      nextProps.ancestorId !== this.props.ancestorId ||
      nextProps.mode !== this.props.mode
    );
  };

  handlePopoverOpen = (event, rstData) => {
    const { getRstMetaData} = this.props;
    const { trplArray } = rstData;

    if (trplArray.length) {
      const trplsIds = trplArray.map(trpl => trpl.tid);

      getRstMetaData(trplsIds, (res) => {
        this.setState({ trplsMetaData: res.trpls_meta_data });
      });
    }
    
    this.setState({ anchorEl: event.currentTarget });
  };

  getGroupWidth = () => {
    const { groupId } = this.props;
    const { screenResized, groupWidth } = this.state;

    if (groupId && (screenResized || groupWidth === 0)){
      let groupWidth = document.getElementById(groupId).offsetWidth;
      this.setState({ groupWidth });

      if (groupWidth < 410) {
        this.setState({ flexSetting: 'wrap', containerDisplay: 'flex', screenResized: false });
      } else {
        this.setState({ flexSetting: 'nowrap', containerDisplay: 'contents', screenResized: false });
      }
    }
  };

  componentDidMount = () => {
    this._isMounted = true;
    this.getGroupWidth();
  };

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidUpdate = () => {
    let resizeId;
    window.addEventListener('resize', (e) => {
      e.preventDefault();
      clearTimeout(resizeId);
      resizeId = setTimeout(this.resizedEnded, 500);
    });
  };

  resizedEnded = () => {
    if (this._isMounted === true) {
      this.setState({ screenResized: true }, () => {
        this.getGroupWidth();
      });
    }
  };

  handlePopoverClose = () => {
    this.setState({ anchorEl: null, trplsMetaData: null });
  };

  render() {
    const {
      flexSetting,
      loadingAddCustom,
      containerDisplay,
    } = this.state;

    const {
      frm,
      rst,
      data,
      item,
      formId,
      account,
      rstData,
      isGroup,
      setTrpl,
      classes,
      groupId,
      concept,
      isNewNode,
      ancestorId,
      getTrplNode,
      saveOnlyForm,
      isAnotherNode,
      accordeonData,
      submitOnlyForm,
      onRstValueEdit,
      getRstMetaData,
      getRstTrplsData,
      removeTrplValue,
      onRstTypeBtnClick,
      onNodeRemoveClick,
      removeAccordeonNode,
      openObjectEditModal,
      toggleUploadImgModal,
      isDisableTrplEditing,
      getAutocompleteTrpls,
      onChangeTextereaHeight,
      updateDataOnRestoreTrpl,
      openTrplRenderPartsModal,
      onAccordeonAddNewNodeClick,
      onWidgetCheckboxesValueEdit,
      onNodeAddDropdownElementClick,
    } = this.props;

    if (rstData && rstData.mode === 'NONE') return null;

    let itemPredicateId = item && item.pid && Array.isArray(item.pid) ? item.pid : rst.custom_pid ? rst.custom_pid : [rst.id];
    let itemTitle = item && item.hide_title ? '' : item && item.title ? item.title : rst.title ? rst.title : '';

    // is component custom and in parent mode
    const customComponentChain = rst && rst.custom_pid ? rst.custom_pid : null;
    const customChainAncestor = accordeonData && rst && rst.custom_pid ? rst.accordeonInfo.concept : concept;
    const customChainFullRstData = customChainAncestor &&
      findLastRstInPredicateChain(customComponentChain, data, customChainAncestor, prdcParamsForm);

    let customChainTrplsData;
    let isPossibleToAddNewNode;
    let customComponentNodeId;

    if (customChainFullRstData) {
      customChainTrplsData = accordeonData
        ? getRstTrplsData(item, customChainFullRstData, ancestorId, accordeonData.concept, accordeonData.rstId, accordeonData.accIndex)
        : getRstTrplsData(item, customChainFullRstData, ancestorId, concept);

      isPossibleToAddNewNode = customChainFullRstData && (customChainFullRstData.subjectMaxBound === 0 ||
        customChainFullRstData.subjectMaxBound > customChainTrplsData.trplArray.length);

      if (rst.custom_pid.length > 1) {
        const firstCustomRstData = findLastRstInPredicateChain(customComponentChain[0], data, customChainAncestor, prdcParamsForm, boxParamsForm);
        const firstRstInCustomChainTrpls = getRstTrplsData(item, firstCustomRstData, ancestorId, concept);

        if (firstRstInCustomChainTrpls && firstRstInCustomChainTrpls.trplArray.length)
        customComponentNodeId = firstRstInCustomChainTrpls.trplArray[0].oid;
      } else customComponentNodeId = ancestorId;
    }

    const showEmptyValOnBounds = frm && (frm.save_only || frm.submit_only);

    return (
      <TableRow
        key={`${itemTitle}.${itemPredicateId}.${groupId}`}
        className={`trpl-form-row ${classes.rstEditRow}`}
        style={{ backgroundColor: customComponentChain ? '#FBFBFB' : '' }}
      >
        <Grid
          container
          style={{
            justifyContent: 'space-between',
            flexWrap: flexSetting,
            alignItems: 'center',
            display: containerDisplay
          }}
          className='trpl-form-row-grid'
        >

          <StyledCell
            key="rst-info"
            className='trpl-form-row-styled-cell'
            style={{
              //display: rst && rst.title ? '' : 'none',
              padding: (itemTitle && isGroup) ? '0px 5px 0px 5px' : '2px',
              verticalAlign: 'middle',
              height: !itemTitle ? '0px' : '',
            }}
          >
            {rst && rst.title ?
              <PidTitle
                rst={rst || customChainFullRstData}
                account={account}
                rstData={rstData || customChainTrplsData}
                classes={classes}
                itemTitle={itemTitle}
                getRstMetaData={getRstMetaData}
                itemPredicateId={itemPredicateId}
              />
            : null}
          </StyledCell>

          <StyledCell
            style={{
              padding: customChainTrplsData ? '0px 5px 0px 0px' : flexSetting === 'nowrap' ? '5px 5px 5px 0px' : '0px 5px 5px 5px',
              //minHeight: flexSetting === 'nowrap' ? '33px' : '',
              width: '100%',
            }}
            key={itemTitle}
          >
          {customChainTrplsData ?
            <React.Fragment>
              {customChainTrplsData.trplArray && customChainTrplsData.trplArray.length ?
                customChainTrplsData.trplArray.map((trpl, trplIndex) => {
                  const isLastPossibleTrpl = (customChainTrplsData.trplArray.length === trplIndex + 1) && !isPossibleToAddNewNode;

                  return (
                    <CustomChainBlock
                      trpl={trpl}
                      classes={classes}
                      trplIndex={trplIndex}
                      isLastPossibleTrpl={isLastPossibleTrpl}
                      removeAccordeonNode={removeAccordeonNode}
                    >
                      {rst.custom_component.map((row, rowIndex) => {
                        return (
                          <div
                            key={rowIndex}
                            className={`
                              ${classes.flex} ${classes.fillAvailable}
                              ${(row.children.length > 1 && rowIndex > 0) ? '' : ''}
                              ${classes.pb5}
                            `}
                          >
                            <TrplFormCustomRow
                              data={data}
                              key={rowIndex}
                              formId={formId}
                              account={account}
                              concept={concept}
                              setTrpl={setTrpl}
                              classes={classes}
                              isGroup={isGroup}
                              groupId={groupId}
                              row={row.children}
                              isNewNode={isNewNode}
                              ancestorId={trpl.oid}
                              getTrplNode={getTrplNode}
                              saveOnlyForm={saveOnlyForm}
                              isAnotherNode={isAnotherNode}
                              getRstMetaData={getRstMetaData}
                              submitOnlyForm={submitOnlyForm}
                              onRstValueEdit={onRstValueEdit}
                              getRstTrplsData={getRstTrplsData}
                              removeTrplValue={removeTrplValue}
                              onRstTypeBtnClick={onRstTypeBtnClick}
                              onNodeRemoveClick={onNodeRemoveClick}
                              openObjectEditModal={openObjectEditModal}
                              toggleUploadImgModal={toggleUploadImgModal}
                              isDisableTrplEditing={isDisableTrplEditing}
                              getAutocompleteTrpls={getAutocompleteTrpls}
                              showEmptyValOnBounds={showEmptyValOnBounds}
                              onChangeTextereaHeight={onChangeTextereaHeight}
                              updateDataOnRestoreTrpl={updateDataOnRestoreTrpl}
                              openTrplRenderPartsModal={openTrplRenderPartsModal}
                              onWidgetCheckboxesValueEdit={onWidgetCheckboxesValueEdit}
                              onNodeAddDropdownElementClick={onNodeAddDropdownElementClick}
                            />
                          </div>
                        )
                      })}
                    </CustomChainBlock>
                  )
                }
              ) : null}

              {isPossibleToAddNewNode && customComponentNodeId ?
                <div
                  className={`${classes.addCustomBlock}`}
                >
                  {loadingAddCustom ?
                    <div className={classes.alignCenter} style={{ height: '20px', position: 'relative', left: '-9px', margin: '3px 0 3px 0' }}>
                      <Loader style={{ zoom: '0.7' }} />
                    </div>
                  :
                    <Button
                      size="small"
                      className={`${classes.btnNormal} ${classes.trplBtn}`}
                      style={{ minWidth: '20px', borderRadius: '10px', height: '20px', width: '20px', padding: 0, fontSize: 12, left: '-10px', margin: '3px 0 3px 1px' }}
                      onClick={() => {
                        this.setState({ loadingAddCustom: true });

                        onAccordeonAddNewNodeClick(customChainFullRstData.oid, customChainFullRstData, null, customComponentNodeId, () => {
                          this.setState({ loadingAddCustom: false });
                        });
                      }}
                    >
                      &#xFF0B;
                    </Button>
                  }
                </div>
              : null}
            </React.Fragment>

          : (rst && rst.type && rst.type === 'custom' && rst.custom_component) ?
            <React.Fragment>
              {rst.custom_component.map((row, index) => {
                return (
                  <div
                    key={index}
                    className={`${classes.flex} ${classes.fillAvailable}
                      ${(rst.custom_component.length > 1 && index !== rst.custom_component.length - 1)
                        ? classes.mb10 : ''}
                    `}
                  >
                    <TrplFormCustomRow
                      data={data}
                      key={index}
                      formId={formId}
                      account={account}
                      concept={concept}
                      setTrpl={setTrpl}
                      classes={classes}
                      isGroup={isGroup}
                      groupId={groupId}
                      row={row.children}
                      isNewNode={isNewNode}
                      ancestorId={ancestorId}
                      getTrplNode={getTrplNode}
                      saveOnlyForm={saveOnlyForm}
                      accordeonData={accordeonData}
                      isAnotherNode={isAnotherNode}
                      getRstMetaData={getRstMetaData}
                      submitOnlyForm={submitOnlyForm}
                      onRstValueEdit={onRstValueEdit}
                      getRstTrplsData={getRstTrplsData}
                      removeTrplValue={removeTrplValue}
                      onRstTypeBtnClick={onRstTypeBtnClick}
                      onNodeRemoveClick={onNodeRemoveClick}
                      openObjectEditModal={openObjectEditModal}
                      toggleUploadImgModal={toggleUploadImgModal}
                      isDisableTrplEditing={isDisableTrplEditing}
                      getAutocompleteTrpls={getAutocompleteTrpls}
                      showEmptyValOnBounds={showEmptyValOnBounds}
                      onChangeTextereaHeight={onChangeTextereaHeight}
                      updateDataOnRestoreTrpl={updateDataOnRestoreTrpl}
                      openTrplRenderPartsModal={openTrplRenderPartsModal}
                      onWidgetCheckboxesValueEdit={onWidgetCheckboxesValueEdit}
                      onNodeAddDropdownElementClick={onNodeAddDropdownElementClick}
                    />
                  </div>
                )
              })}
            </React.Fragment>
          :
            <TrplFormValRenderer
              rst={rst}
              frm={frm}
              data={data}
              item={item}
              formId={formId}
              setTrpl={setTrpl}
              classes={classes}
              isGroup={isGroup}
              groupId={groupId}
              rstData={rstData}
              isNewNode={isNewNode}
              ancestorId={ancestorId}
              getTrplNode={getTrplNode}
              saveOnlyForm={saveOnlyForm}
              isAnotherNode={isAnotherNode}
              submitOnlyForm={submitOnlyForm}
              onRstValueEdit={onRstValueEdit}
              removeTrplValue={removeTrplValue}
              onRstTypeBtnClick={onRstTypeBtnClick}
              onNodeRemoveClick={onNodeRemoveClick}
              openObjectEditModal={openObjectEditModal}
              toggleUploadImgModal={toggleUploadImgModal}
              isDisableTrplEditing={isDisableTrplEditing}
              getAutocompleteTrpls={getAutocompleteTrpls}
              showEmptyValOnBounds={showEmptyValOnBounds}
              onChangeTextereaHeight={onChangeTextereaHeight}
              updateDataOnRestoreTrpl={updateDataOnRestoreTrpl}
              openTrplRenderPartsModal={openTrplRenderPartsModal}
              onWidgetCheckboxesValueEdit={onWidgetCheckboxesValueEdit}
              onNodeAddDropdownElementClick={onNodeAddDropdownElementClick}
            />}
          </StyledCell>
        </Grid>
      </TableRow>
    );
  }
};

export default connect((state) => ({ account: state.meta.account }), {})(TrplFormRow);
